// removed by extract-text-webpack-plugin
module.exports = {"slick-slider":"slick-slider","slick-list":"slick-list","dragging":"dragging","slick-track":"slick-track","slick-loading":"slick-loading","slick-slide":"slick-slide","slick-initialized":"slick-initialized","slick-vertical":"slick-vertical","slick-arrow":"slick-arrow","slick-hidden":"slick-hidden","Slide":"Slide","slick-prev":"slick-prev","prev":"prev","Slide__prev":"Slide__prev","change":"change","Slide__change":"Slide__change","slick-next":"slick-next","next":"next","Slide__next":"Slide__next","slick-dots":"slick-dots","slick-active":"slick-active"};


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/styles.css
// module id = 715
// module chunks = 0 1